import { useI18n } from 'panda-i18n';
import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { CnIcon } from '@/components/cn-icon';
import { CnButton } from '@/components/cn-button';
import { CnDrawer } from '@/components/cn-drawer';
import { mergeProps } from '@/utils/with-default-props';
import { CnPage } from '@/components/cn-page';
import { CnDrawerHeader } from '../cn-drawer/header';
import { CnButtonGroup } from '../cn-button-group';
const cls = 'cn-ui-m-dialog-fullpage';
const defaultProps = {
    visible: false,
};
export const CnDialogFullpage = (props) => {
    const { footer, onClose, onCancel, className, children, onOk, okProps, title, visible: visibleProps, ...others } = mergeProps(defaultProps, props);
    const hideFooter = footer === null || footer === false;
    const $i18n = useI18n();
    const [visible, setVisible] = useState(visibleProps);
    useEffect(() => {
        setVisible((prev) => {
            if (prev === visibleProps)
                return prev;
            return visibleProps;
        });
    }, [visibleProps]);
    const renderFooter = () => {
        if (hideFooter)
            return null;
        if (footer) {
            if (React.isValidElement(footer)) {
                // @ts-ignore 忽略displayName
                const displayName = footer.type?.displayName;
                if (['CnPageFooter', 'CnButtonGroup'].includes(displayName)) {
                    return footer;
                }
            }
            return (React.createElement(CnButtonGroup, { fullWidth: true, size: "large" }, footer));
        }
        return (React.createElement(CnButtonGroup, { fullWidth: true, size: "large" },
            React.createElement(CnButton, { type: "secondary", size: "large", fullWidth: true, onClick: () => {
                    onCancel && onCancel();
                } }, $i18n.get({
                id: 'Cancel',
                dm: '取消',
                ns: 'CnDialogFullpage',
            })),
            React.createElement(CnButton, { type: "primary", size: "large", fullWidth: true, onClick: () => {
                    onOk && onOk();
                }, ...okProps }, $i18n.get({
                id: 'Determine',
                dm: '确定',
                ns: 'CnDialogFullpage',
            }))));
    };
    return (React.createElement(CnDrawer, { visible: visible, onClose: onClose, onCancel: onCancel, className: classNames(cls, className), ...others, placement: "right", closeMode: [], noCard: true },
        React.createElement(CnDrawerHeader, null,
            React.createElement("div", { className: `${cls}-header` },
                React.createElement("div", { className: `${cls}-header-close`, onClick: (e) => {
                        e.stopPropagation();
                        setVisible(false);
                        // 只需要执行一个，一码多端兼容
                        if (onClose) {
                            onClose();
                        }
                        else if (onCancel) {
                            onCancel();
                        }
                    } },
                    React.createElement(CnIcon, { size: "large", type: "close" })),
                React.createElement("div", { className: `${cls}-header-title` }, title))),
        React.createElement(CnPage, { footer: renderFooter(), className: classNames(`${cls}-body`) }, children)));
};
